import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResourceModel } from '../../../core/models/resources/resource.model';

@Component({
    selector: 'app-reset-filter-btn',
    templateUrl: './reset-filter-btn.component.html',
    styleUrls: ['./reset-filter-btn.component.scss'],
    standalone: false
})
export class ResetFilterBtnComponent {
	@Output() resetFilter: EventEmitter<ResourceModel> = new EventEmitter<ResourceModel>();
	@Input() disableClearFilter = true;

	onReset() {
	    this.resetFilter.emit();
	}
}
